<script>
import { Radio } from 'element-ui';

export default {
  extends: Radio,
};
</script>

<style lang="scss">
.el-radio-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.el-radio {
  display: flex;
  margin-bottom: 5px;
  &:hover {
    .el-radio__inner {
      background-color: rgba($--color-primary, .2);
      border-color: $--radio-input-border-color;
      box-shadow: 0 0 0 10px rgba($--color-primary, .2);
      transition: box-shadow .5s ease-in-out, background-color .5s ease-in-out;
      &::after {
        background-color: transparent;
      }
    }
  }

  &:focus:not(.is-focus, :active, .is-disabled, .is-checked) {
    .el-radio__inner {
      box-shadow: 0 0 0 10px rgba($--color-primary, .2);
    }
  }

  &.is-checked {
    .el-radio__inner {
      background-color: transparent;
      &::after {
        background-color: $--color-primary;
      }
    }

    &:hover {
      .el-radio__inner {
        border-color: $--color-primary;
        box-shadow: 0 0 0 0 transparent;
      }
    }

    .el-radio__label {
      color: $--color-text-regular;
    }
  }

  &.is-disabled {
    pointer-events: none;
  }
}

.el-radio__label {
  word-break: normal;
  white-space: normal;
}

.el-radio__inner {
  background-color: transparent;
  transition: box-shadow .5s ease-in-out, background-color .5s ease-in-out;

  &::after {
    width: 8px;
    height: 8px;
    background-color: transparent;
    transition: background-color .5s ease-in-out;
  }
}

.el-radio--normal-text {
  font-weight: 400;
}

// ------------------------------ NEW DESIGN ------------------------------

.el-radio--new-design {
  --radio-border-color: #{$--border-primary};
  --radio-active-color: #{$--color-primary};

  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 400;
  min-height: 36px;
  padding: 6px;
  margin: 0;

  .el-radio__input {
    line-height: 0;
  }

  .el-radio__inner {
    background-color: transparent;
    border: 2px solid var(--radio-border-color);
    height: 20px;
    margin: 2px;
    transition: box-shadow .5s ease-in-out, background-color .5s ease-in-out;
    width: 20px;

    &::after {
      background-color: transparent;
      transition: background-color .5s ease-in-out;
      height: 10px;
      width: 10px;
    }
  }

  .el-radio__label {
    font-size: rem(16px);
    line-height: 150%;
    padding-left: 0;
    white-space: normal;
    word-break: normal;
  }

  &:hover,
  &:focus {
    .el-radio__inner {
      background-color: $--color-background;
      border-color: var(--radio-border-color);
      box-shadow: 0 0 0 8px $--color-background !important;
      transition: box-shadow .5s ease-in-out, background-color .5s ease-in-out;

      &::after {
        background-color: transparent;
      }
    }
  }

  &.is-checked {
    &:hover {
      .el-radio__inner {
        border-color: var(--radio-active-color);
      }
    }

    .el-radio__inner {
      background-color: transparent;
      border-color: var(--radio-active-color);

      &::after {
        background-color: var(--radio-active-color);
      }
    }

    .el-radio__label {
      color: $--color-text-regular;
    }
  }

  &.is-disabled {
    pointer-events: none;

    .el-radio__inner,
    .el-radio__input.is-disabled.is-checked .el-radio__inner {
      background-color: transparent;
      border-color: $--color-primary-disabled;
    }

    .el-radio__input.is-disabled.is-checked .el-radio__inner {
      &::after {
        background-color: $--color-primary-disabled;
      }
    }

    .el-radio__input.is-disabled + span.el-radio__label {
      color: $--color-primary-disabled;
    }

    img {
      opacity: .5;
    }
  }
}

.el-radio--tile {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  border: 1px dashed transparent;
  border-radius: 16px;
  padding: 8px;
  margin: 0;

  .el-radio__input {
    flex-shrink: 0;
    line-height: 0;

    .el-radio__inner {
      width: 18px;
      height: 18px;
      border: 1px solid $--border-color-base;
    }

    &.is-checked {
      .el-radio__inner {
        position: relative;

        @include railsiconfont('check');

        &::before {
          color: $--color-white;
          font-size: rem(12px);
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          z-index: 2;
        }

        &::after {
          background-color: $--color-primary;
          width: 18px;
          height: 18px;
          z-index: 1;
        }
      }
    }
  }

  .el-radio__label {
    padding-left: 12px;
    font-size: rem(13px);
    font-weight: 600;
  }

  &:active,
  &.is-checked {
    background-color: $--color-background;
    border-color: $--border-color-base;
  }

  &:hover {
    border-color: $--border-color-base;

    .el-radio__inner {
      background-color: $--color-background;
      box-shadow: 0 0 0 5px $--color-background;
    }
  }
}

.el-radio--with-description {
  align-items: flex-start;
  padding-top: 5px;
  padding-bottom: 1px;

  .el-radio__input {
    margin-top: 1px;
  }

  .el-radio__label--description {
    font-size: rem(12px);
    line-height: 170%;
    color: $--color-text-blue;
  }

  &.is-disabled {
    .el-radio__label--description {
      color: $--color-primary-disabled;
    }
  }
}

.el-radio--light {
  --radio-border-color: #{$--color-white};
  --radio-active-color: #{$--color-white};

  .el-radio__label,
  .el-radio__label--description {
    color: $--color-white;
  }

  &:hover,
  &:focus {
    .el-radio__inner {
      background-color: $--color-primary-dark-3;
      box-shadow: 0 0 0 8px $--color-primary-dark-3 !important;
    }
  }

  &.is-checked {
    .el-radio__label {
      color: $--color-white;
    }
  }
}
</style>
